<template>
  <ul class="chat-groups">

    <li class="loading" v-if="showLoading"><i class="fa fa-spinner fa-spin fa-fw"></i> 訊息讀取中...</li>
    <li class="empty-chat-groups" v-if="showEmptyChatGroups">目前沒有任何訊息</li>

    <chat-group
      v-for="chatGroup in chatGroups"
      :chat-group="chatGroup"
      :current-chat-group="currentChatGroup"
      :current-user-id="currentUserId"
    >
    </chat-group>
    <li class="get-more-chat-groups-btn" v-if="showGetMoreChatGroups()" @click="getMoreChatGroups()">取得更多群組</li>
  </ul>
</template>

<script>
import ChatGroup from './chat_group.vue'

export default {
  props: ['chatGroups', 'currentChatGroup', 'currentUserId', 'chatGroupLoaded', 'chatGroupsReachTheEnd'],
  data() {
    return {
    };
  },
  components: {
    ChatGroup
  },
  created() {},

  computed: {
    'showLoading'() {
      return !this.chatGroupLoaded;
    },

    'showEmptyChatGroups'() {
      return this.chatGroupLoaded && (this.chatGroups.length === 0);
    }
  },

  methods: {

    showGetMoreChatGroups() {
      return !this.chatGroupsReachTheEnd && (this.chatGroups.length !== 0);
    },
    getMoreChatGroups() {
      return eventHub.$emit('get-more-chat-groups', this.chatGroups[this.chatGroups.length - 1]);
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/chat_groups.vue